import Api from "./api"

// TODO for some useEffect reason we used promise instead of async await here ... really necessary?
const validate = (code) => {
  return new Promise((resolve, reject) => {
    Api.get(`validatevoucher?code=${code}`)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
  
}

export default {validate}